package com.rylcart.cp.ui

import androidx.compose.runtime.Composable
import com.rylcart.cp.ui.components.Toast
import com.rylcart.cp.ui.screens.LoginScreen
import com.rylcart.cp.ui.screens.NewTenantScreen
import com.rylcart.cp.ui.screens.TenantDetailScreen
import com.rylcart.cp.ui.screens.TenantsScreen
import com.rylcart.cp.ui.state.AppStateProvider
import com.rylcart.cp.ui.state.LocalApp
import com.rylcart.cp.ui.state.Route
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.renderComposable

fun main() {
    renderComposable(rootElementId = "root") {
        AppStateProvider { App() }
    }
}

@Composable
fun App() {
    val app = LocalApp.current
    if (app.token == null) {
        LoginScreen()
    } else {
        Div(attrs = { classes("shell") }) {
            Sidebar()
            Div(attrs = { classes("main") }) {
                when (val r = app.route) {
                    is Route.Tenants         -> TenantsScreen()
                    is Route.NewTenant       -> NewTenantScreen()
                    is Route.TenantDetail    -> TenantDetailScreen(r.id)
                }
            }
        }
    }
    Toast()
}

@Composable
private fun Sidebar() {
    val app = LocalApp.current
    val active = app.route
    Div(attrs = { classes("sidebar"); style { property("position", "relative") } }) {
        H1 { Text("RylCart"); Span(attrs = { classes("dot") }) { Text(".") } }
        Nav {
            navLink("Tenants", "#/tenants", active is Route.Tenants || active is Route.TenantDetail)
            navLink("+ New tenant", "#/tenants/new", active is Route.NewTenant)
        }
        Div(attrs = { classes("me") }) {
            Text("Signed in")
            Div(attrs = { style { property("margin-top", "8px") } }) {
                A(href = "#", attrs = {
                    style { property("color", "var(--lime)"); property("text-decoration", "none") }
                    onClick { e -> e.preventDefault(); app.setToken(null) }
                }) { Text("Sign out") }
            }
        }
    }
}

@Composable
private fun navLink(label: String, href: String, isActive: Boolean) {
    A(href = href, attrs = { if (isActive) classes("active") }) { Text(label) }
}
